import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import { title, t } from '~/helpers';
import AuthLayout from '~/pages/_layouts/auth';
import DefaultLayout from '~/pages/_layouts/default';
import { store } from '~/store';

export default function RouteWrapper({
  component: Component,
  isPrivate,
  fullScreen,
  title: Title,
  ...rest
}) {
  const { signed } = store.getState().auth;

  const translate = useSelector((state) => state.language);

  useEffect(() => {
    if (!isEmpty(Title)) {
      title(t(Title));
    } else {
      title('');
    }
  }, [translate, Title]);

  if (!signed && isPrivate) {
    return <Redirect to="/" />;
  }

  if (signed && !isPrivate) {
    return <Redirect to="/dashboard" />;
  }

  const Layout = signed ? DefaultLayout : AuthLayout;

  return (
    <Route
      {...rest}
      render={(props) =>
        fullScreen ? (
          <Component {...props} />
        ) : (
          <Layout>
            <Component {...props} />
          </Layout>
        )
      }
    />
  );
}

RouteWrapper.propTypes = {
  isPrivate: PropTypes.bool,
  fullScreen: PropTypes.bool,
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
  title: PropTypes.string,
};

RouteWrapper.defaultProps = {
  isPrivate: false,
  fullScreen: false,
  title: '',
};
